<template>
    <v-card outlined flat class="card--info" tile>
        <section-header :title="title" :action="true" :small="true" class="pl-4 pr-0 py-2"></section-header>
        <div class="card--info-scroll-target" data-target="contained">
            <div class="card--info-content" data-content="scrollable">
                <slot></slot>
            </div>
        </div>
    </v-card>
</template>
<script>
export default {
    props: ['title'],

    mounted() {
        this.$nextTick(() => {
            const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
            scrollTarget.addEventListener('scroll', this.onScrollY, false)
        })
    },

    destroyed() {
        const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
        scrollTarget.removeEventListener('scroll', this.onScrollY, false)
    },

    methods: {
        onReachScrollBottom(val) {
            if (val) {
                this.$emit('scrolledTillBottom', true)
            } else {
                this.$emit('scrolledTillBottom', false)
            }

        }
    }
}
</script>